/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AssignmentStatus } from './AssignmentStatus';
import {
    AssignmentStatusFromJSON,
    AssignmentStatusFromJSONTyped,
    AssignmentStatusToJSON,
    AssignmentStatusToJSONTyped,
} from './AssignmentStatus';

/**
 * 
 * @export
 * @interface UpdateAssignmentStatusRequest
 */
export interface UpdateAssignmentStatusRequest {
    /**
     * 
     * @type {AssignmentStatus}
     * @memberof UpdateAssignmentStatusRequest
     */
    status: AssignmentStatus;
}



/**
 * Check if a given object implements the UpdateAssignmentStatusRequest interface.
 */
export function instanceOfUpdateAssignmentStatusRequest(value: object): value is UpdateAssignmentStatusRequest {
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function UpdateAssignmentStatusRequestFromJSON(json: any): UpdateAssignmentStatusRequest {
    return UpdateAssignmentStatusRequestFromJSONTyped(json, false);
}

export function UpdateAssignmentStatusRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateAssignmentStatusRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'status': AssignmentStatusFromJSON(json['status']),
    };
}

export function UpdateAssignmentStatusRequestToJSON(json: any): UpdateAssignmentStatusRequest {
    return UpdateAssignmentStatusRequestToJSONTyped(json, false);
}

export function UpdateAssignmentStatusRequestToJSONTyped(value?: UpdateAssignmentStatusRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': AssignmentStatusToJSON(value['status']),
    };
}

